import Axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'
import storage, { TOKEN_INFO } from './storage'
import { toLogin } from '@shared/utils'
import { doDecrypt, doEncrypt } from './crypt'

export const baseURL = process.env.npm_config_baseapi || import.meta.env.VITE_BASE_API || '/api'

const request = Axios.create({
  baseURL
  // timeout: 20000 // 请求超时 20s
})

// 前置拦截器（发起请求之前的拦截）
request.interceptors.request.use(
  (config) => {
    if (config.requestType === 'upload') {
      config.headers['Content-Type'] = 'multipart/form-data'
    }
    const { tokenName, tokenValue } = storage.getItem(TOKEN_INFO) || {}
    if (tokenValue) {
      config.headers[tokenName] = tokenValue
    }

    // 数据加密，所有需要加密的接口应该都是json格式的
    if (config.encrypt && config.data) {
      config.data = doEncrypt(config.data)
    }
    return config
  },
  (error) => {
    console.log(error) // for debug

    return Promise.reject(error)
  }
)

let isAlert = false
// 后置拦截器（获取到响应时的拦截）
request.interceptors.response.use(
  async (response) => {
    let res = response.data
    const config = response.config

    // 处理文件流，请求config中加 responseType: 'blob2'配置, 这个配置会返回后端设置的文件名
    if (config.responseType === 'blob2') {
      if (response.status != 200) return Promise.reject('status is not 200') // 状态码不等于200
      const filename = decodeURIComponent(response.headers['content-disposition'].split('filename=')[1])
      const blob = new Blob([response.data], { type: response.headers['content-type'] })
      return { blob, filename }
    }
    // 处理文件流，请求config中加 responseType: 'blob'配置
    if (config.responseType === 'blob') {
      if (response.headers['content-type'] === 'application/json') {
        // 如果返回的文件流是json格式，说明是错误信息
        const textData = await new Response(response.data).json()
        return Promise.reject(textData)
      } else {
        if (response.status != 200) return Promise.reject('status is not 200') // 状态码不等于200
        return new Blob([response.data], { type: response.headers['content-type'] })
      }
    }

    // 处理加密数据
    if (response.headers?.encrypt) {
      res = doDecrypt(res)
    }

    if (res.code !== 200) {
      // 其他状态错误处理
      if ([401].includes(res.code) && !config.hide401) {
        // 退出登录
        if (!isAlert) {
          isAlert = true
          ElMessageBox.alert('登录失效，请重新登录', '提示', {
            showClose: false,
            center: true,
            callback: (action) => {
              if (action === 'confirm') {
                isAlert = false
                toLogin()
              }
            }
          })
        }

        return
      }
      if (!config.hideErrorMsg) {
        ElMessage.error(res.msg || '未知错误，请联系管理员')
      }

      return Promise.reject(res.msg)
    } else {
      return res.data
    }
  },
  (error) => {
    if (error.response && error.response.data) {
      const code = error.response.status
      const msg = error.response.data.message
      ElMessage.error(`Code: ${code}, Message: ${msg}`)
      console.error(`[Axios Error]`, error.response)
    } else {
      ElMessage.error(`${error}`)
    }
    return Promise.reject(error)
  }
)

export default request
